import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from "react";
import { Alert, Box, Button, Dropdown, Icon } from "~/components-shared";
import { useTranslation } from "react-i18next";
import mixpanel from "mixpanel-browser";
import { useDrop } from "react-dnd";
import InsightsConfigureViewDropdownItem from "~/components/InsightsConfigureViewDropdownItem";
import update from "immutability-helper";
import insightsActionCreators from "~/store/insights/actions";
import { useDispatch, useSelector } from "react-redux";
import insightsSelectors from "~/store/insights/selectors";
import styled from "styled-components";
import { StatusStateEnum } from "~/types/enums";
const StyledBox = styled(Box)`
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.primary;
}};
  position: sticky;
  bottom: 0;
  z-index: 1;
`;
const InsightsConfigureViewDropdown = _ref2 => {
  let {
    ...rest
  } = _ref2;
  const {
    t
  } = useTranslation();
  const view = useSelector(insightsSelectors.getView);
  const viewState = useSelector(insightsSelectors.getViewStatus);
  const viewError = useSelector(insightsSelectors.getViewError);
  const config = view || [];
  const error = viewError;
  const dispatch = useDispatch();
  const [, drop] = useDrop(() => ({
    accept: "insightsWidget"
  }));
  const handleMove = newView => {
    mixpanel.track(`Member Insights – Update View`, {
      newView
    });
    dispatch(insightsActionCreators.updateViewSucceeded(newView));
  };
  const findItem = useCallback(id => {
    const item = config.filter(c => c.type === id)[0];
    return {
      item,
      index: config.indexOf(item)
    };
  }, [config]);
  const moveItem = useCallback((id, atIndex) => {
    const {
      item,
      index
    } = findItem(id);
    handleMove(update(config, {
      $splice: [[index, 1], [atIndex, 0, item]]
    }));
  }, [findItem, config]);
  const handleReset = callback => {
    dispatch(insightsActionCreators.updateViewStarted(undefined, () => {
      callback();
    }));
  };
  const handleSubmit = callback => {
    dispatch(insightsActionCreators.updateViewStarted(config, () => {
      callback();
    }));
  };
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    direction: "bottomLeft",
    handlerProps: {
      s: {
        py: 2.8,
        px: 4
      },
      color: "translucent",
      elemBefore: /*#__PURE__*/React.createElement(Icon, {
        src: "tune",
        scale: 5,
        s: {
          mr: 1
        }
      })
    },
    handler: t("InsightsConfigureViewDropdown.configureView")
  }, rest), _ref3 => {
    let {
      isOpen,
      onItemClick
    } = _ref3;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen,
      width: "400px",
      id: "notificationList"
    }, error && /*#__PURE__*/React.createElement(Alert, {
      severity: "danger",
      s: {
        mb: 3
      },
      fullWidth: true
    }, error), /*#__PURE__*/React.createElement(Box, {
      direction: "column",
      gap: 3,
      align: "stretch",
      s: {
        p: 3
      },
      fullWidth: true
    }, config.map(item => /*#__PURE__*/React.createElement("div", {
      key: item.type,
      ref: drop
    }, /*#__PURE__*/React.createElement(InsightsConfigureViewDropdownItem, {
      item: item,
      findItem: findItem,
      moveItem: moveItem
    })))), /*#__PURE__*/React.createElement(StyledBox, {
      align: "center",
      justify: "end",
      s: {
        p: 3
      },
      gap: 3
    }, /*#__PURE__*/React.createElement(Button, {
      color: "translucent",
      onClick: onItemClick,
      s: {
        py: 2
      },
      fontSize: 3.5
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      color: "translucent",
      onClick: () => handleReset(onItemClick),
      loading: viewState === StatusStateEnum.LOADING,
      s: {
        py: 2
      },
      fontSize: 3.5
    }, "Reset"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => handleSubmit(onItemClick),
      loading: viewState === StatusStateEnum.LOADING,
      s: {
        py: 2,
        px: 8
      },
      fontSize: 3.5
    }, "Save")));
  });
};
export default InsightsConfigureViewDropdown;